export default __webpack_public_path__ + "static/media/chair.79b50f80.jpeg";